import { render, staticRenderFns } from "./Criar-Lembrete-Medicacao.vue?vue&type=template&id=6fd1bce5&"
import script from "./Criar-Lembrete-Medicacao.vue?vue&type=script&lang=js&"
export * from "./Criar-Lembrete-Medicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Criar-Lembrete-Medicacao.vue"
export default component.exports